import { faChevronDown, faChevronUp } from "@fortawesome/pro-light-svg-icons";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import React, { PropsWithChildren, useState } from "react";
import { Dropdown } from "react-bootstrap";
import { IMAGES } from "src/assets";
import { colors } from "src/styles";
import styled from "styled-components";

interface FlyDownProps {
  userInfo: { firstName?: string; lastName?: string; photo?: string };
}

const FlyDown = ({ userInfo: { firstName, lastName, photo }, children }: PropsWithChildren<FlyDownProps>) => {
  const [isVisible, setIsVisible] = useState(false);
  const onToggleHandler = (isOpen: boolean) => {
    setIsVisible(isOpen);
  };
  return (
    <Dropdown onToggle={(isOpen: boolean) => onToggleHandler(isOpen)}>
      <ToggleButton>
        <ProfileImg src={photo || IMAGES.DEFAULT_PROFILE_ICON_FLY_DOWN} />
        <ProfileInfo>
          {firstName} {lastName}
        </ProfileInfo>
        <Icon icon={isVisible ? faChevronUp : faChevronDown} />
      </ToggleButton>

      <ListWrapper>{children}</ListWrapper>
    </Dropdown>
  );
};

const Icon = styled(FontAwesomeIcon)`
  color: ${colors.grey.dark};
  cursor: pointer;
`;

const ToggleButton = styled(Dropdown.Toggle)`
  border-radius: 0;
  background-color: ${colors.grey.light14};
  color: ${colors.black.dark1};
  font-weight: 500;
  font-size: 13px;
  padding: 8px 12px;
  border: 1px solid ${colors.grey.light3};
  display: flex;
  align-items: center;
  &:hover,
  &:focus,
  &:active,
  &:active:focus {
    box-shadow: unset;
    border: 1px solid ${colors.grey.light3};
    background-color: ${colors.grey.light14};
    color: ${colors.black.dark1};
  }
  &::after {
    content: unset;
  }
`;

const ProfileImg = styled.img`
  width: 32px;
  height: 32px;
  margin-right: 12px;
  border-radius: 50px;
`;

const ProfileInfo = styled.span`
  padding-right: 8px;
`;

const ListWrapper = styled(Dropdown.Menu)`
  min-width: 220px;
  width: 100%;
  border: 1px solid ${colors.grey.light3};
  box-shadow: none;
  background-color: ${colors.white.default};
  border-radius: 0;
  padding: 8px 16px;
`;

export default FlyDown;
